import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ApiResponse } from "../../../services/api";
import Client from "../../../types/client";

interface ClientTableProps {
    rows: any[];
    columns: GridColDef[];
    height?: number;
    width?: string;
    getRowClassName?: (params: { indexRelativeToCurrentPage: number }) => string; 
    apiResponse: ApiResponse<Client> | null;
    paginationModel: any; 
    setPaginationModel: any;
}

const ClientTable: React.FC<ClientTableProps> = ({
    rows,
    columns,
    height = 500,
    width = "100%",
    getRowClassName,
    apiResponse,
    paginationModel, 
    setPaginationModel,
}) => {
  const rowHeight = 55;
  const baseHeight = 100;

  const computedHeight =
  paginationModel.pageSize <= 5
    ? paginationModel.pageSize * rowHeight + baseHeight
    : height;

  return (
    <div style={{ height: computedHeight, width }}> 
      <DataGrid
        rows={rows}
        columns={columns}
        pageSizeOptions={[5, 10, 20, 100]}
        pagination
        checkboxSelection={false}
        getRowClassName={getRowClassName}
        paginationMode='server'
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        rowCount={apiResponse?.data?.totalItems ?? 0}
        disableRowSelectionOnClick
        sx={{
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#f5f5f5",
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "white",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#b2d1ff",
        },
        "& .MuiTablePagination-selectLabel": {
          marginTop: "14px",
        },
        "& .MuiTablePagination-displayedRows": {
          marginTop: "14px",
        },
        "& .MuiDataGrid-cell[id='id']": {
          cursor: 'pointer !important',
        },
        "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
          outline: "none",
        },
        "& .MuiDataGrid-row:focus, & .MuiDataGrid-row:focus-within": {
          outline: "none",
        }
        }}
      />
    </div>
  );
};

export default ClientTable;
